'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.updateMobileDevice = exports.removeMobileDevice = exports.addMobileDevice = exports.fetchUsersFilters = exports.fetchUsers = exports.searchUser = exports.setNewPassword = exports.validateTempHash = exports.requestPasswordReset = exports.signupClientAdmin = exports.getUsersInRole = exports.getUsersInAccount = exports.getUserById = exports.getUserChildren = exports.deleteUser = exports.saveEditedUser = exports.fetchCurrentUser = exports.createNewUser = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createNewUser = exports.createNewUser = function createNewUser(user) {
	return (0, _callApi2.default)('POST', '/user', user, 'application/json');
};
var fetchCurrentUser = exports.fetchCurrentUser = function fetchCurrentUser(f) {
	return (0, _callApi2.default)('GET', '/user');
};
var saveEditedUser = exports.saveEditedUser = function saveEditedUser(user) {
	return (0, _callApi2.default)('PUT', '/user/edit/' + user._id, user, 'application/json');
};
var deleteUser = exports.deleteUser = function deleteUser(user) {
	return (0, _callApi2.default)('PUT', '/user/delete/' + user._id, {}, 'application/json');
};
var getUserChildren = exports.getUserChildren = function getUserChildren(settings, account) {
	var _ref = settings || {},
	    limit = _ref.limit,
	    offset = _ref.offset;

	if (account) return (0, _callApi2.default)('POST', '/user/children', limit && offset ? { limit: limit, offset: offset, account: account } : { account: account }, 'application/json');else return (0, _callApi2.default)('POST', '/user/children', limit && offset ? { limit: limit, offset: offset } : {}, 'application/json');
};
var getUserById = exports.getUserById = function getUserById(user_id) {
	return (0, _callApi2.default)('GET', '/user/' + user_id, null, 'application/json');
};
var getUsersInAccount = exports.getUsersInAccount = function getUsersInAccount(account_id) {
	return (0, _callApi2.default)('GET', '/users/account' + (account_id ? '/' + account_id : ''), null, 'application/json');
};
var getUsersInRole = exports.getUsersInRole = function getUsersInRole(_ref2) {
	var role_id = _ref2.role_id,
	    account_id = _ref2.account_id;
	return (0, _callApi2.default)('POST', '/users/role', { role_id: role_id, account_id: account_id }, 'application/json');
};
var signupClientAdmin = exports.signupClientAdmin = function signupClientAdmin(user) {
	return (0, _callApi2.default)('POST', '/user/signup', user, 'application/json');
};
var requestPasswordReset = exports.requestPasswordReset = function requestPasswordReset(email) {
	return (0, _callApi2.default)('POST', '/user/password-reset-email', { email: email }, 'application/json');
};
var validateTempHash = exports.validateTempHash = function validateTempHash(id, temp_hash) {
	return (0, _callApi2.default)('POST', '/user/validate-temp-hash/', { id: id, temp_hash: temp_hash }, 'application/json');
};
var setNewPassword = exports.setNewPassword = function setNewPassword(id, password, password_confirm, temp_hash) {
	return (0, _callApi2.default)('POST', '/user/set-new-password/' + id, { password: password, password_confirm: password_confirm, temp_hash: temp_hash }, 'application/json');
};
var searchUser = exports.searchUser = function searchUser(name, account) {
	return (0, _callApi2.default)('POST', '/users/search', { name: name, account: account }, 'application/json');
};
var fetchUsers = function fetchUsers(_ref3) {
	var filters = _ref3.filters,
	    size = _ref3.size,
	    offset = _ref3.offset,
	    sort = _ref3.sort,
	    args = _objectWithoutProperties(_ref3, ['filters', 'size', 'offset', 'sort']);

	return (0, _callApi2.default)('POST', '/users', _extends({ filters: filters, size: size, offset: offset, sort: sort }, args), 'application/json');
};
exports.fetchUsers = fetchUsers;
var fetchUsersFilters = exports.fetchUsersFilters = function fetchUsersFilters() {
	return (0, _callApi2.default)('GET', '/users/filters', null, 'application/json');
};
var addMobileDevice = exports.addMobileDevice = function addMobileDevice(device) {
	return (0, _callApi2.default)('POST', '/user/device', device, 'application/json');
};
var removeMobileDevice = exports.removeMobileDevice = function removeMobileDevice(device) {
	return (0, _callApi2.default)('DELETE', '/user/device', device, 'application/json');
};
var updateMobileDevice = exports.updateMobileDevice = function updateMobileDevice(device) {
	return (0, _callApi2.default)('PUT', '/user/device', device, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/users.js
// module id = 747
// module chunks = 0